/* eslint-disable */
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export default {
    init() {
        // JavaScript to be fired on all pages

        //mobile menu

        var isMenuOpened;

        document.querySelector("#mobile-menu--trigger").addEventListener("click", openMobileMenu);
        document.querySelector("#mobile-menu--exit").addEventListener("click", closeMobileMenu);

        function openMobileMenu() {
            document.querySelector('.mobile-menu').classList.add('mobile-menu--active');
            document.querySelector('.header').classList.add('header--active');
            window.isMenuOpened = true;
        }

        function closeMobileMenu() {
            document.querySelector('.mobile-menu').classList.remove('mobile-menu--active');
            document.querySelector('.header').classList.remove('header--active');
            window.isMenuOpened = false;
        }

        //swiper

        // if ($('.image-slider__slider').length) {

        //   Swiper.use([Navigation, Pagination]);

        //   new Swiper('.image-slider__slider', {
        //     slidesPerView: 1,
        //     navigation: {
        //       nextEl: ".swiper-button-next",
        //       prevEl: ".swiper-button-prev",
        //     },
        //     pagination: {
        //       el: ".swiper-pagination",
        //       clickable: true,
        //     },
        //   });
        // }

        if ($('.card-grid').length) {

            const cards = document.querySelectorAll('.card-grid .card-grid__inner');

            cards.forEach(function (card) {
                card.addEventListener('click', function () {
                    const link = card.querySelector('a');
                    if (link) {
                        link.click();
                    }
                });
            });            
        }

        if ($('.slider-images__wrap').length) {

            Swiper.use([Autoplay])

            new Swiper('.slider-images__wrap', {
                slidesPerView: "auto",
                spaceBetween: 32,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    // when window width is >= 500px
                    500: {
                        // slidesPerView: 3,
                        spaceBetween: 20
                    },
                    // when window width is >= 767px
                    767: {
                        // slidesPerView: 5,
                        spaceBetween: 30
                    },
                    // when window width is >= 1023px
                    1023: {
                        // slidesPerView: 7,
                        spaceBetween: 40
                    }
                }
            });
        }

        if ($('.card-dubble-swiper-wrapper').length) {

            Swiper.use([Autoplay, Pagination, Navigation])

            new Swiper('.card-dubble-swiper-wrapper', {
                slidesPerView: 2.2,
                spaceBetween: 15,
                // loop: true,
                pagination: {
                    el: ".swiper-pagination-cards",
                    type: "progressbar",
                },
                navigation: {
                    nextEl: ".nav-next",
                    prevEl: ".nav-prev",
                },
            });
        }

        if ($('.vertical-slider-swiper').length) {

            Swiper.use([Autoplay, Pagination, Navigation])

            new Swiper('.vertical-slider-swiper', {
                slidesPerView: 1.4,
                spaceBetween: 30,
                pagination: {
                    el: ".vertical-swiper-pagination",
                    type: "progressbar",
                },
                navigation: {
                    nextEl: ".vertical-swiper-next",
                    prevEl: ".vertical-swiper-prev",
                },
                breakpoints: {
                    // when window width is >= 300px
                    300: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },

                    // when window width is >= 500px
                    500: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    // when window width is >= 767px
                    767: {
                        slidesPerView: 1.2,
                        spaceBetween: 30,
                    },
                    // when window width is >= 1023px
                    1023: {
                        slidesPerView: 1.4,
                        spaceBetween: 30,
                    }
                },
            });
        }

        if ($('.personeel-slider-swiper').length) {

            Swiper.use([Navigation, Pagination]);

            new Swiper('.personeel-slider-swiper', {
                slidesPerView: 3.2,
                navigation: {
                    nextEl: ".personeel-slider-button-next",
                    prevEl: ".personeel-slider-button-prev",
                },
                pagination: {
                    el: ".personeel-slider-pagination",
                    type: "progressbar",
                },
                breakpoints: {
                    // when window width is >= 300px
                    300: {
                        slidesPerView: 1.5,
                        spaceBetween: 5,
                    },

                    // when window width is >= 500px
                    500: {
                        slidesPerView: 2,
                        spaceBetween: 7.5,
                    },
                    // when window width is >= 767px
                    767: {
                        slidesPerView: 2.4,
                        spaceBetween: 10,
                    },
                    // when window width is >= 1023px
                    1023: {
                        slidesPerView: 3.2,
                        spaceBetween: 15,
                    }
                },
            });
        }

        if ($('.slideshow__inner').length) {

            Swiper.use([Navigation, Pagination]);

            new Swiper('.slideshow__inner', {
                slidesPerView: 4.5,
                navigation: {
                    nextEl: ".slideshow-slider-button-next",
                    prevEl: ".slideshow-slider-button-prev",
                },
                pagination: {
                    el: ".slideshow-slider-pagination",
                    type: "progressbar",
                },
                breakpoints: {
                    // when window width is >= 300px
                    300: {
                        spaceBetween: 1.3,
                        slidesPerView: 1.5,
                    },

                    // when window width is >= 500px
                    500: {
                        spaceBetween: 2.5,
                        slidesPerView: 2,
                    },
                    // when window width is >= 767px
                    767: {
                        spaceBetween: 15,
                        slidesPerView: 3.5,
                    },
                    // when window width is >= 1023px
                    1023: {
                        spaceBetween: 25,
                    }
                },
            });
        }

        const contentTriggers = document.querySelectorAll('.trigger');  //pakt alle items met class
        const contentBlocks = document.querySelectorAll('.menu-content-toggle');

        //zet de eerste altijd op actief op pagina load

        if (contentBlocks.length) {

            contentBlocks[0].classList.add('active');
            contentTriggers[0].classList.add('blue');


            for (let i = 0; i < contentTriggers.length; i++) {
                contentTriggers[i].addEventListener('click', function () {
                    //remove all blue and active classes
                    for (let x = 0; x < contentTriggers.length; x++) {
                        contentTriggers[x].classList.remove('blue')
                        contentBlocks[x].classList.remove('active')
                    }

                    this.classList.add('blue')
                    contentBlocks[i].classList.add('active')
                });
            }
        }


        const buttonTriggerContactForm = document.querySelectorAll('.contact-trigger-button'); //pakt alle elementen met class
        const contactFormBlock = document.querySelectorAll('.content-split-form');

        if (contactFormBlock.length) {

            contactFormBlock[0].classList.add('active');   //show first form default
            buttonTriggerContactForm[0].classList.add('gray');

            for (let i = 0; i < buttonTriggerContactForm.length; i++) {
                buttonTriggerContactForm[i].addEventListener('click', function () {
                    //remove all gray and active classes
                    for (let x = 0; x < buttonTriggerContactForm.length; x++) {
                        buttonTriggerContactForm[x].classList.remove('gray')
                        contactFormBlock[x].classList.remove('active')
                    }

                    this.classList.add('gray')
                    contactFormBlock[i].classList.add('active')
                });
            }
        }

        //
        const menuContentTriggers = document.querySelectorAll('.menu-content-circles-trigger');  //pakt alle items met class
        const menuContentBlocks = document.querySelectorAll('.menu-content-circles-toggle')

        if (menuContentBlocks.length) {

            menuContentBlocks[0].classList.add('active');
            menuContentTriggers[0].classList.add('blue');


            for (let i = 0; i < menuContentTriggers.length; i++) {
                menuContentTriggers[i].addEventListener('click', function () {
                    //remove all blue and active classes
                    for (let x = 0; x < menuContentTriggers.length; x++) {
                        menuContentTriggers[x].classList.remove('blue')
                        menuContentBlocks[x].classList.remove('active')
                    }
                    this.classList.add('blue')
                    menuContentBlocks[i].classList.add('active')
                });
            }
        }

        //valbeveiliging circles
        const valbeveiligingCircle = document.getElementsByClassName('menu-content-circles-trigger');
        if (valbeveiligingCircle.length) {
            for (let i = 0; i < valbeveiligingCircle.length; i++) {
                // console.log(valbeveiligingCircle);
                // console.log(i);
                valbeveiligingCircle[i].querySelector('.line').firstChild.innerHTML = i + 1;
                // valbeveiligingCircle[i].children[0].innerHTML = i + 1;
            }
        }

        //
        const shopContentGrid = document.querySelectorAll('.shop__inner-grid');
        const pageCounter = document.querySelector('#page-counter');
        if (pageCounter == null || pageCounter == undefined) {
            return 'error';
        }
        const currentCounter = pageCounter.querySelector('#current-slide');
        const shopButtons = document.querySelector('#shop_buttons');

        let slideIndex = 0;
        currentCounter.innerHTML = slideIndex + 1;
        var shoplist = [];
        var shoplistcount = 0;


        if (shopContentGrid.length) {
            shopContentGrid[0].classList.add('active');

            //get current id count of active item
            const ShopNext = document.querySelector('.shop-next');
            const ShopPrev = document.querySelector('.shop-prev');

            ShopPrev.classList.add("opacity");

            //hidden shoplist input field id
            var hiddenShopList = document.getElementById('input_3_18');

            ShopNext.addEventListener('click', function (e) {
                slideIndex++;
                if (slideIndex < shopContentGrid.length) {
                    shopContentGrid[slideIndex - 1].classList.remove('active');
                    shopContentGrid[slideIndex].classList.add('active');
                    currentCounter.innerHTML = slideIndex + 1;
                } else {
                    slideIndex = 0;
                    shopContentGrid[shopContentGrid.length - 1].classList.remove('active');
                    shopContentGrid[slideIndex].classList.add('active');
                    currentCounter.innerHTML = slideIndex + 1;
                }
                if (slideIndex <= 0) {
                    ShopPrev.classList.add("opacity");
                } else {
                    ShopPrev.classList.remove("opacity");
                }
                if (slideIndex >= shopContentGrid.length - 1) {
                    ShopNext.classList.add("opacity");
                } else {
                    ShopNext.classList.remove("opacity");
                }
            });
            ShopPrev.addEventListener('click', function (e) {
                slideIndex--;
                if (slideIndex >= 0) {
                    shopContentGrid[slideIndex + 1].classList.remove('active');
                    shopContentGrid[slideIndex].classList.add('active');
                    currentCounter.innerHTML = slideIndex + 1;
                } else {
                    slideIndex = shopContentGrid.length - 1;
                    shopContentGrid[0].classList.remove('active');
                    shopContentGrid[slideIndex].classList.add('active');
                    // currentCounter.innerHTML = slideIndex + 1;
                    currentCounter.innerHTML = shopContentGrid.length;
                }
                if (slideIndex <= 0) {
                    ShopPrev.classList.add("opacity");
                } else {
                    ShopPrev.classList.remove("opacity");
                }
                if (slideIndex >= shopContentGrid.length - 1) {
                    ShopNext.classList.add("opacity");
                } else {
                    ShopNext.classList.remove("opacity");
                }
            });

            //popup
            const iets = document.querySelectorAll('#item-information');
            Array.from(iets).map(iets => iets.addEventListener('click', (e) => {
                const post_id = iets.dataset.postid;
                var productData = {
                    action: 'valbeveiliging_single_item',
                    post_id: post_id,
                };
                $.ajax({
                    type: 'post',
                    dataType: 'json',
                    url: '/wp-admin/admin-ajax.php',
                    data: productData,
                    beforeSend: function () {
                        console.log('voor data verstuurd is.');
                    },
                    success: function (data) {              
                        //create popup
                        const shopPopupBlock = document.querySelector('#model-target');
                        shopPopupBlock.classList.add('visible');
                        const responseFiller = document.querySelector('#model-response');
                        responseFiller.innerHTML = Object.values(data)[3];


                        //exit popup
                        const shopPopupExit = document.querySelector('.response-exit_circle');
                        shopPopupExit.addEventListener('click', function () {
                            shopPopupBlock.classList.remove('visible');
                        });
                        console.log('successfully sent data');
                    },
                    error: function (e) {
                        console.log('Event failed: ' + e);
                    },
                });
            }));

            //shoplist list
            const shopButtonAdd = document.querySelectorAll('#shop-add-item');
            Array.from(shopButtonAdd).map(shopButtonAdd => shopButtonAdd.addEventListener('click', (e) => {
                const totalEl = document.querySelector('#total_price');
                let total = totalEl.textContent;
                let prodPrice = shopButtonAdd.dataset.price;

                prodPrice = parseFloat(prodPrice);
                total = parseFloat(total);

                let totalCalc = total + prodPrice;

                totalEl.innerHTML = totalCalc.toFixed(2);

                const shopListAllItems = document.querySelectorAll('#list-item');
                var informatie = {    //de informatie voor de ajax call
                    action: 'valbeveiliging_single_item_list_add',  //de functie die getriggerd word
                    product_id: shopButtonAdd.dataset.itemid,  //het ID van de item 
                };
                $.ajax({
                    type: 'post',
                    dataType: 'json',
                    url: '/wp-admin/admin-ajax.php',
                    data: informatie,
                    beforeSend: function (e) {
                        var productid = shopButtonAdd.dataset.itemid;
                        document.getElementById(productid).classList.add('loading');
                        //check if exists in list
                        for (let i = 0; i < shopListAllItems.length; i++) {
                            if (shopListAllItems[i].dataset.productid == productid) {
                                console.log('er is een overeenkomend item in shopping list');
                                document.getElementById(productid).classList.add('loading');

                                setTimeout(() => {
                                    document.getElementById(productid).classList.remove('loading');
                                }, 1000);

                                //update qty
                                for (let i = 0; i < Object.keys(shoplist).length; i++) {
                                    if (shoplist[i].productid == productid) {
                                        if (shoplist[i].qty > 0) {  //if it has a qty
                                            shoplist[i].qty = shoplist[i].qty + 1;  //+1 to qty

                                            //update select dropdown
                                            const selectDropdown = document.getElementsByClassName('select-update');
                                            const options = Array.from(selectDropdown[i].options);
                                            const optionToSelect = options.find(item => item.value == shoplist[i].qty);
                                            selectDropdown[i].value = optionToSelect.value;

                                            //voeg item toe aan hidden list
                                            hiddenShopList.setAttribute('value', JSON.stringify(shoplist))
                                        }
                                    }
                                }

                                return false; //er bestaat al een item met dit ID 
                            }
                        }
                    },
                    success: function (data) {
                        var productid = parseInt(data['product_id']);
                        document.getElementById(productid).classList.remove('loading');

                        //creeer shoplist products
                        shoplist = [...shoplist, {
                            productid: productid,
                            qty: 1
                        }];

                        const shopListTarget = document.getElementById('item-list-target');
                        //creeer data div voor shop list
                        var div = document.createElement('div');
                        div.className = 'item';
                        div.id = 'list-item';
                        div.setAttribute("data-productid", data['product_id']);
                        div.innerHTML = Object.values(data)[2];
                        shopListTarget.appendChild(div);  //vul target met nieuwe div

                        //voeg item toe aan hidden list
                        hiddenShopList.setAttribute('value', JSON.stringify(shoplist))

                        //update select and qty
                        const select = document.getElementsByClassName('select-update');
                        if (select.length) {
                            for (let i = 0; i < Object.keys(shoplist).length; i++) {
                                select[i].addEventListener('change', function () {
                                    for (let i = 0; i < Object.keys(shoplist).length; i++) {
                                        if (shoplist[i].productid == productid) {
                                            shoplist[i].qty = parseInt(select[i].value);
                                        }
                                    }
                                });
                            }
                        }
                        console.log('data transfer successvol');
                    },
                    error: function (e) {
                        console.log('Event failed: ' + e);
                    },
                });
            }));

            //remove item from shoplist
            const exitClickShopList = document.querySelectorAll('#item-list-exit')
            document.querySelector('.shop__outer-list').addEventListener('click', function (e) {

                if (e.target.classList.contains('exit_push')) {
                    const totalEl = document.querySelector('#total_price');
                    let total = totalEl.textContent;
                    let prodPrice = e.target.parentNode.dataset.price;

                    console.log(e.target);

                    prodPrice = parseFloat(prodPrice);
                    total = parseFloat(total);

                    total = total - prodPrice;

                    totalEl.innerHTML = total.toFixed(2);

                    //remove from hidden list
                    var removeValue = e.target.closest('#list-item').dataset.productid;   //get value to remove
                    shoplist = shoplist.filter(item => item.productid !== parseInt(removeValue)); //grab every result that is not equel to removeValue 

                    //remove the div 
                    e.target.closest('#list-item').remove();
                }
            });

            //hide / show form blocks
            const formToggleAdress = document.querySelector('#tF');
            const shopAdressToggle = document.getElementById('field_3_11');
            shopAdressToggle.style.display = 'none';
            formToggleAdress.addEventListener('click', function () {
                if (shopAdressToggle.style.display == 'none') {
                    shopAdressToggle.style.display = 'block';
                } else {
                    shopAdressToggle.style.display = 'none';
                }
            });
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js